import { ENDPOINT } from '../../constants/server/api';
import { fetchApiData } from '../../utils/apiUtils';

export const getPackages = params => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.PACKAGE}/pagination`,
    params: {
      page: params?.page,
      perPage: params?.perPage,
      s: params?.s,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const getPackageLogs = params => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.PACKAGE}/Log/pagination/list`,
    params: {
      package_main_id: params?.package_main_id,
      type: params?.type || 'ALL',
      start_date: params?.start_date || '2024-01-01',
      end_date: params?.end_date || '2025-01-01',
      page: params?.page,
      perPage: params?.perPage,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const exportPackageToExcel = searchTerm => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.PACKAGE}/excel`,
    params: {
      s: searchTerm || ''
    },
    responseType: 'blob',
    dispatch
  });

  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'รายการแพ็คเกจ.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
  return null;
};

export const packageLogToExcel = params => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.PACKAGE}/Log/excel`,
    params: {
      business_group_id: params?.business_group_id,
      type: params?.type || 'ALL',
      start_date: params?.start_date || '2024-01-01',
      end_date: params?.end_date || '2025-01-01'
    },
    responseType: 'blob',
    dispatch
  });

  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'รายการ log แพ็คเกจ.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
  return null;
};

export const getPermissions = packageType => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.PERMISSION}`,
    params: {
      packageType: packageType || 'MAIN'
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const createPackage = packageData => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.PACKAGE}`,
    data: packageData,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const getPackageById = id => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.PACKAGE}/${id}`,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateMainPermission = (id, updateData) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.PACKAGE}/${id}/main-permission`,
    data: updateData,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};
export const deletePackage = id => async dispatch => {
  const data = await fetchApiData({
    method: 'delete',
    endpoint: `${ENDPOINT.PACKAGE}/${id}`,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateAdditionalPermission = (id, updateData) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.PACKAGE}/${id}/additional-permission`,
    data: updateData,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const getPackageDefaults = () => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.PACKAGE}/package-default/list`,
    dispatch,
    useAuth: true
  });

  if (data) {
    return data;
  }
  return null;
};

export const updatePackageDefault = id => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.PACKAGE}/package-default/${id}`,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};
